export enum CommunityPostReactionContentEnum {
  LIKE = '👍',
}